import { useState } from "react";
import { toast } from "sonner";
import { FileText, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CATALOG } from "@/lib/catalog";
import { api, errorText } from "@/lib/api";

const field = "w-full rounded-lg border border-line bg-surface px-3 py-2.5 text-sm outline-none focus:border-brand";
const EMPTY = { name: "", phone: "", vehicle: "", service: CATALOG[16].name, request: "" };

const QuoteForm = ({ onDone }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (p) => setF({ ...f, ...p });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/quotes", f);
      toast.success("¡Solicitud enviada! Te contactaremos pronto con tu cotización.");
      setF(EMPTY);
      onDone();
    } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="quote-form">
      <label className="block text-xs font-semibold text-mute">Nombre *<input required minLength={2} className={`${field} mt-1`} value={f.name} onChange={(e) => set({ name: e.target.value })} data-testid="quote-name-input" /></label>
      <label className="block text-xs font-semibold text-mute">Teléfono / WhatsApp (10 dígitos) *<input required type="tel" className={`${field} mt-1`} value={f.phone} onChange={(e) => set({ phone: e.target.value })} data-testid="quote-phone-input" /></label>
      <label className="block text-xs font-semibold text-mute">Vehículo (marca, modelo, año) *<input required minLength={2} className={`${field} mt-1`} value={f.vehicle} onChange={(e) => set({ vehicle: e.target.value })} data-testid="quote-vehicle-input" /></label>
      <label className="block text-xs font-semibold text-mute">Servicio
        <select className={`${field} mt-1`} value={f.service} onChange={(e) => set({ service: e.target.value })} data-testid="quote-service-select">
          {CATALOG.map((s) => <option key={s.name} value={s.name}>{s.name}</option>)}
        </select>
      </label>
      <label className="block text-xs font-semibold text-mute">¿Qué necesitas o qué síntomas tiene?<textarea rows={3} className={`${field} mt-1`} value={f.request} onChange={(e) => set({ request: e.target.value })} data-testid="quote-request-input" /></label>
      <button className="btn-gold w-full" disabled={busy} data-testid="quote-submit-btn">{busy && <Loader2 size={16} className="animate-spin" />} Enviar solicitud</button>
    </form>
  );
};

export const QuoteButton = ({ className = "btn-ghost", testId = "quote-btn", label = "Solicitar cotización" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)} data-testid={testId}><FileText size={16} /> {label}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md bg-white max-h-[92vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-extrabold">Solicita tu cotización</DialogTitle>
            <DialogDescription>Déjanos tus datos y te enviamos el presupuesto. También puedes llamar al 999-191-9300.</DialogDescription>
          </DialogHeader>
          <QuoteForm onDone={() => setOpen(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};
